import Action from './Action';
import * as ActionMethods from './ActionMethods';
import CatalogManagementService from '../services/CatalogManagementService';
import OfferService from '../services/OfferService';
import Offer from '../model/catalog/Offer';
import EventDispatcher from "../framework/EventDispatcher";

export const FETCH_OFFERS = "FETCH_OFFERS";

export default function reducer(state = {user: null}, action = {}) {
	switch (action.type) {
		case EventDispatcher.successAction(FETCH_OFFERS):
		const {offerList} = action.data;
		return {
			...state,
			offerList
		};
		break;
		default:
		return state;
	}
}

export function fetchOffers() {
	return dispatch => {
		EventDispatcher.loading(dispatch, FETCH_OFFERS);
		let offerList = [];
		CatalogManagementService.listOffers()
			.then(result => {
				const offerPromises = [];
				result.map(offer => offerPromises.push(OfferService.find(offer.id)));
				return Promise.all(offerPromises.map(p => p.catch(() => undefined)));
				})
			.then(offers => {
				offers = offers || [];
				offers.forEach(offerDto => {
					const {actionStatus, offerTemplate} = offerDto || {};
					if (actionStatus == null || actionStatus.status === "FAIL") {
						this.fail(actionStatus);
					} else {
						const dateTime = new Date().getTime();
						if (!offerTemplate.disabled && !!offerTemplate.bomCode
								&& ( offerTemplate.lifeCycleStatus == "ACTIVE"
									|| offerTemplate.lifeCycleStatus == "IN_TEST"
									|| offerTemplate.lifeCycleStatus == "LAUNCHED")){
										if (( offerTemplate.validFrom < dateTime && offerTemplate.validTo > dateTime)
											|| (offerTemplate.validFrom < dateTime && offerTemplate.validTo == null)
											|| (offerTemplate.validFrom == null && offerTemplate.validTo > dateTime)
											|| (offerTemplate.validFrom == null && offerTemplate.validTo == null)) {
												offerList.push(new Offer(offerDto));
											}
										}
									}
								});
        
				EventDispatcher.success(dispatch, FETCH_OFFERS, {offerList});
			})
			.catch(error => {
				EventDispatcher.error(dispatch, FETCH_OFFERS, error);
			});
	};
}



// WEBPACK FOOTER //
// ./src/opencell/actions/OfferActions.js